<template>
  <div class="policy-container">
    <headerIndex/>
    <!--标题/来源-->
    <div class="policy-title">
      <p class="title">{{ policyDetail.title }}</p>
      <p class="source">来源：{{ policyDetail.source }}</p>
    </div>
    <!--正文-->
    <div class="policy-content">
      <div class="rich-html" v-html="policyDetail.content"></div>
    </div>
    <!--相关推荐-->
    <div class="policy-recommend">
      <p class="title">相关推荐</p>
      <div class="recommend-list" v-for="recommend of policyDetail.recommend" @click="recommendDetails(recommend)">
        <p>
          <span class="adRegions">【{{ recommend.city_name }}{{recommend.area_name ? '.' + recommend.area_name : ''}}】</span>
          <span class="recommend-title">{{ recommend.title }}</span>
        </p>
      </div>
    </div>
    <home_footer></home_footer>
    <Hang/>
  </div>
</template>
<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from '@/components/footer/home_footer';
import Hang from "@/components/Hang/Hang";
import {biddingInfo} from '@/api/interfaceApi'

export default {
  components: {headerIndex, home_footer, Hang},
  name: 'policyDetails',
  data() {
    return {
      policyDetail: {},
    };
  },
  mounted() {
    this.getDetails();
  },
  methods: {
    getDetails() {
      let cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
      biddingInfo({bidding_id: this.$route.query.id, uid: cid != 0 && cid != undefined ? cid : 0}).then((res) => {
        if (res.code == 200) {
          this.policyDetail = res.content;
        }
      });
    },
    /*查看用户信息*/
    authorPage(bid) {
      let routeData = this.$router.resolve({
        name: "userInfo",
        query: {bid: bid},
        params: {cid: this.cid},
        path: '/userInfo/index',
      });
      window.open(routeData.href, '_blank')
    },
    recommendDetails(row){
      let routeData = this.$router.resolve({
        name: "policyDetails",
        query: {
          id: row.bidding_id,
        },
        path: '/article/policyDetails',
      });
      window.open(routeData.href, '_blank')
    }
  }
};
</script>

<style lang="scss" scoped>
.policy-container {
  background: #F1F1F1;

  .policy-content {
    min-height: 100vh;
    background-color: #fff;
    margin: 10px 18% 20px;
    padding: 20px;
  }

  .policy-title {
    margin: 10px 18% 0px;

    .title {
      font-size: 24px;
      font-family: 'SourceHanSansCN';
      color: #333333;
      margin-block-end: 0px;
      margin-block-start: 0px;
      cursor: pointer;
    }

    .source {
      font-size: 14px;
      color: #333333;
      font-family: "SourceHanSansCN";
      margin-block-end: 0px;
      margin-block-start: 0px;
      padding: 10px 0px 0px;
      cursor: pointer;
    }
  }

  .policy-recommend {
    margin: 0px 18% 0px;

    .title {
      font-size: 20px;
      color: #333333;
      font-family: "SourceHanSansCN";
      border-left: 3px solid #fe273b;
      margin-block-start: 0px;
      margin-block-end: 10px;
      padding-left: 10px;
    }

    .recommend-list {
      background: #FFFFFF;
      display: flex;
      justify-content: space-between;
      padding: 0px 20px;
      cursor: pointer;

      .adRegions {
        font-size: 16px;
        color: #333333;
      }

      .recommend-title {
        font-size: 16px;
        color: #333333;
        position: absolute;
        width: 45%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .time {
        color: #AAAAAA;
        font-size: 16px;
      }
    }
  }
}

.author {
  &:hover {
    color: #fe273b;
  }
}
</style>
<style scoped>
.rich-html >>> img {
  max-width: 100% !important;
  margin: 20px 0;
}

.rich-html >>> p {
  font-size: 16px;
  color: #333;
  margin-block-start: 0em;
  margin-block-end: 0em;
}
</style>